import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "../sch-test/delhi-prefit.module.css";
import Prelimsmain from "../../assets/images/home/Banner/Prestorming-Web-Banner-Click-Here.jpg";
import MobPrelimsmain from "../../assets/images/home/Mob_Banner/Prestorming-Mob-Banner-Click-Here.jpg";
import csatWebBanner from "../../assets/images/upsc/prestorming/UPSC-Moct-test-Web-Banner-26.jpg";
import arRow from "../../assets/images/arrow.svg";
import csatMobBanner from "../../assets/images/upsc/prestorming/UPSC-Moct-test-Mob-Banner-26.jpg";
import redrightarrow from "../../assets/images/contact/redrightarrow.png";
import NewiconB from "../../assets/images/header/newanimation.gif";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import { useState,useEffect } from 'react';
import Form from "./form";
import Validationform from "../../components/validationform";
import {useRouter} from 'next/router';
import Link from "next/link";
import NewiconA from "../../assets/images/header/modalnew.png";

const allIndiaPrelimsMockTestSeries = () => {

    const feestructure = [
        { date: "GS Paper I", cont: "03.05.2026", cont1: "09:30 am to 11:30 am" },
        { date: "GS Paper II", cont: "03.05.2026", cont1: "02:30 pm to 04:30 pm" }
      ]
    
      const feestructure2 = [
        { date: "GS Paper I", cont: "10.05.2026", cont1: "09:30 am to 11:30 am" },
        { date: "GS Paper II", cont: "10.05.2026", cont1: "02:30 pm to 04:30 pm" }
      ]
    
      const feestructure3 = [
        { date: "GS Paper I", cont: "17.5.2026", cont1: "09:30 am to 11:30 am" },
        { date: "GS Paper II", cont: "17.5.2026", cont1: "02:30 pm to 04:30 pm"}
      ]

      const jsonLd ={
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": " All India UPSC Prelims Mock Test | Shankar IAS Academy",
        "url": "https://www.shankariasacademy.com/all-india-upsc-prelims-mock-test/",
        "Image":
        "https://www.shankariasacademy.com/_next/static/media/UPSC-Moct-test-Web-banner.919f45c6.jpg",
        "description": "Join Shankar IAS Academy’s All India UPSC Prelims Mock Test for expert insights, performance analysis & crack the exam with confidence. Register Now!"
      }
      //const [linkType, setLinkType] = useState(null);

      //const router = useRouter();
     // const { query } = router;
      //const parameter1 = query.MobileNo;

//   useEffect(() => {
//     const checkVisibility = () => {
//       const now = new Date();
//       const options = { timeZone: 'Asia/Kolkata', hour12: false, hour: 'numeric', minute: 'numeric', weekday: 'short' };
//       const formatter = new Intl.DateTimeFormat('en-US', options);
//       const parts = formatter.formatToParts(now);
//       const day = parts.find(part => part.type === 'weekday').value;
//       const hours = parseInt(parts.find(part => part.type === 'hour').value, 10);
//       const minutes = parseInt(parts.find(part => part.type === 'minute').value, 10);
//       const isSunday = day === 'Sun';
//       const afterStart = hours > 8 || (hours === 8 && minutes >= 15);
//       const beforeNoon = hours < 17;
//       //const afterNoon = hours >= 13 && hours < 17;
//       const afterEvening = hours >= 17;
//       const isMondayToSaturday = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri','Sat'].includes(day);

//       if (isSunday && afterStart && beforeNoon) {
//         setLinkType('morning');
//       } else if (isSunday && afterEvening) {
//         setLinkType('evening');
//       }
//       else if (isMondayToSaturday || (isSunday && hours >= 17)) {
//         setLinkType('evening');
//       } 
//       else {
//         setLinkType(null);
//       }
//     };

//     // Check immediately and then every minute
//     checkVisibility();
//     const interval = setInterval(checkVisibility, 60000);

//     // Cleanup interval on component unmount
//     return () => clearInterval(interval);
//   }, []);

  return (
        <>

            <Head>
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
                <meta charset="UTF-8" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="noindex,nofollow" />
                <meta name="robots" content="noindex, nofollow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
                <title> All India UPSC Prelims Mock Test | Shankar IAS Academy</title>
                <meta name="title" content=" All India UPSC Prelims Mock Test | Shankar IAS Academy" />
                <meta name="description" content="Join Shankar IAS Academy’s All India UPSC Prelims Mock Test for expert insights, performance analysis & crack the exam with confidence. Register Now!" />
				<meta name="keywords" content="Free All India UPSC Prelims Mock Test , All India UPSC Prelims Mock Test, UPSC All India Prelims Mock Test , All India Open Mock Test , UPSC Mock Test , Prelims Mock Test , Mock Test for UPSC Free, Free Mock Test for UPSC Prelims, UPSC Prelims Mock Test Free." />
                <link rel="canonical" href="https://www.shankariasacademy.com/all-india-upsc-prelims-mock-test/" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content=" All India UPSC Prelims Mock Test | Shankar IAS Academy" />
                <meta property="og:description" content="Join Shankar IAS Academy’s All India UPSC Prelims Mock Test for expert insights, performance analysis & crack the exam with confidence. Register Now!" />
                <meta property="og:url" content="https://www.shankariasacademy.com/all-india-upsc-prelims-mock-test/" />
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
            </Head>

    <style jsx>{`
        
        /* Blink animation example */
        .blink {
          animation: blink-animation 1s steps(2, start) infinite;
          background: red;
          color:#fff !important;
          padding:4px;
         
        }
        @keyframes blink-animation {
          to {
            visibility: hidden;
          }
        }
      `}</style>

    <Navbar title="sch-test"/>

            <div className="container">
                <div className='row'>
                    <div className='col'>
                       <h1 className={`${styles.pagemaintitle}`}> All India UPSC Prelims Mock Test 2026</h1>
                    </div>
                </div>
                <div className='row pt-2 d-none d-md-block'>
                    <div className='col'>
                        <Link href="/upsc-prestorming-prelims-test-series">
                            <Image src={Prelimsmain} className="img-fluid w-100" alt="Free All India Prelims Mock Test" title="Free All India Prelims Mock Test" />
                        </Link>
                    </div>
                </div>
                <div className='row pt-4 d-block d-md-none'>
                    <div className='col'>
                        <Link href="/upsc-prestorming-prelims-test-series">
                            <Image src={MobPrelimsmain} className="img-fluid w-100" alt="Free All India Prelims Mock Test" title="Free All India Prelims Mock Test" />
                        </Link>
                    </div>
                </div>
            </div>

        {/* <div className="container-fluid pt-4"  style={{background: '#F4F6F8'}}>
            <div className="container">
                <div className="col-12 text-center pt-2 pb-2 ">
                <h3 className={`${styles.sectiontitle} pt-3`}>UPSC 2025 - All India Prelims Mock Test 3 Link <br /></h3>
                    <button style={{background:'#e1dfdf'}} className={`${styles.normalbutton} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}>
                        <a  className='text-danger' target='_blank' href="https://onlineexams.shankariasacademy.com/products/all-india-mock-3/">Click Here Test Link</a> 
                    </button>
            </div>  
            </div>
        </div> */}
        
         <div className="container-fluid pt-2 pb-4"  style={{background: '#F4F6F8'}}>
            <h3 className={`${styles.sectiontitle} text-center pt-3`}> UPSC - Prelims 2026 - Cut off Prediction<br /></h3>
                <div className="col-12 text-center  pb-2 ">
                    <span className="d-block"><Image src={redrightarrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link" /><a className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/SIA-UPSC-PRELIMS-2026-CUT-OFF-PREDICTION.pdf">UPSC - 2026 - Expected Prelims Cut off (Released)<span></span>  </a> <br /></span>    
                
                     {/* <span className="d-block "> <Image src={redrightarrow} className={`${styles.img} img-fluid`} alt="arrow icon" title="Link" /> <a  className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/UPSC-Prelims-GS-2026-Shankar-Ias-Parliament-Reflections.pdf">UPSC PRELIMS 2026 (GS - PAPER 1) Shankar Ias Parliament Reflections</a><Image src={NewiconB} width="32" height="30" alt="New_icon" className="img-fluid mx-2" /></span> */}
                
                </div> 
        </div> 

      <div className="container-fluid py-4"  style={{background: '#F4F6F8'}}>
           
            
            {/*    <div className="col-12 text-center  pb-2 pt-2">
                <span className="d-block ">  <a  className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/mock/GS-TEST-2-TVM-RESULT.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"/>ALL INDIA UPSC Mock Test 2 - GS - Paper I (Trivandrum)-Results</a></span>
                <span className="d-block"><a className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/mock/CSAT-TEST-2-TVM-RESULT.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  />ALL INDIA UPSC Mock Test 2 - GS - Paper II (Trivandrum)-Results<span></span>  </a> <br /></span>    
                <span className="d-block"><a className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/mock/2026-05-03-AIMT-GS-TVM-TEST1-RESULT.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  />ALL INDIA UPSC Mock Test 1 - GS - Paper I (Trivandrum)-Results<span></span>  </a> <br /></span>    
            </div>  */}
      
            <h3 className={`${styles.sectiontitle} text-center pt-3`}> UPSC Civil Services Preliminary Examination 2026 –  Answer Key<br /></h3>
            <div className="col-12 text-center  pb-2 pt-2">
                <span className="d-block ">  <a  className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/Shankar-IAS-Prelims-2026-Paper-1-Answer-Key.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  />UPSC PRELIMS 2026 -GS PAPER 1 - ANSWER KEY [Set-D] - Released - (Typo Error Updated Key)</a></span>
                <span className="d-block"><a className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/UPSC-2025-CSAT-PAPER-II-SERIES-D-ANSWERKEY.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  />UPSC PRELIMS 2026 - GS PAPER 2 - ANSWER KEY [Set-D] - Released<span></span>  </a> <br /></span>    
            </div>
        </div> 

    

    {/* <div className="container-fluid py-4"  style={{background: '#F4F6F8'}}>
        <div className="container">
            <div className="row pb-2">
                <div className={`col-12 col-lg-5 pt-3 pt-lg-0 order-2 order-lg-1 ${styles.container}`}>
                    <h2 className={styles.sectiontitle}>
                        Mock Test Schedule Details
                    </h2>
                    {[
                        { title: "Mock Test 1", data: feestructure },
                        { title: "Mock Test 2", data: feestructure2 },
                        { title: "Mock Test 3", data: feestructure3 }
                    ].map((section, idx) => (
                        <div key={idx} className={styles.card}>
                            <div className={styles.cardHeader}>
                                {section.title}
                            </div>
                            <div className={styles.cardBody}>
                                    {section.data.map((item, index) => (
                                    <div key={index} className={styles.item}>

                                       
                                        <div className={styles.mobileView}>
                                        <div className={styles.date}>{item.date}</div>
                                        <div className={styles.text}>{item.cont || item.cont1}</div>
                                        <div className={styles.subtext}>{item.cont1 || item.cont2}</div>
                                        </div>

                                       
                                        <div className={styles.desktopView}>
                                        <div className={styles.date}>{item.date}</div>
                                        <div className={styles.text}>{item.cont || item.cont1}</div>
                                        <div className={styles.subtext}>{item.cont1 || item.cont2}</div>
                                        </div>

                                    </div>
                                    ))}
                            </div>
                        </div>
                    ))}
                </div>

                <div className="col-xl-7  col-lg-7 pt-4 pb-3 pb-lg-0 col-12 order-1 order-lg-2" >
                    <div className='text-center mt-4 pt-4 mb-2 text-danger h3'>Registration Closed</div>
                    <Form />

                    <h3 className= "text-center pt-3" style={{ fontSize:"22px" , fontWeight:"bold"}}>The original UPSC Prelims Hall Ticket is mandatory for Mock Test - III</h3>
                    <h3 className={`${styles.sectiontitle} text-center pt-3`}> INSTRUCTIONS <br /></h3> 
                        
                    <div className="col-12 text-center  pb-2 pt-2">
                        <span className="d-block ">  <a  className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/mock/UPSC-OFFLINE-INSTRUCTIONS-2026-TEST3.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  />UPSC - ALL INDIA MOCK TEST 3 - OFFLINE INSTRUCTIONS</a></span>
                        <span className="d-block"><a className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/mock/UPSC-MOCK-ONLINE-INSTRUCTIONS-2026-TEST3.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  />UPSC - ALL INDIA MOCK TEST 3 - ONLINE INSTRUCTIONS<span></span>  </a> <br /></span> 
                    </div> 

                    <div className="col-12 text-center pt-2 pb-2 " style={{background: '#ffffff'}}>
                            <h3 className={`${styles.sectiontitle} pt-3`}> All India UPSC Prelims Mock Test 2026 - Download Hall Ticket <br /></h3>
                            <button style={{background:'#e1dfdf'}} className={`${styles.normalbutton} ${styles.brochurebtn} pt-2 pe-3 pb-2 ps-3 mt-2 d-inline-block`}>
                                <a  className='text-danger' target='_blank' href="/hallticket">Click Here </a> 
                            </button>
                        </div>

                         <h3 className={`${styles.sectiontitle} text-center pt-3`}> All India UPSC Prelims Mock Test III 2026 - Result <br /></h3>
            <div className="col-12 text-center  pb-2 pt-2">
                <span className="d-block ">  <a  className='text-danger ' target='_blank' href="https://shankariasacademy.in-maa-1.linodeobjects.com/UPSC-Prelims-Key/UPSC-Mock-Test-3-GS-Paper-I-Results.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  />ALL INDIA UPSC Mock Test III - GS - Paper I -Results</a></span>
                <span className="d-block"><a className='text-danger ' target='_blank' href="https://shankariasacademy.in-maa-1.linodeobjects.com/UPSC-Prelims-Key/UPSC-Mock-Test-3-GS-Paper-II-Results.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  />ALL INDIA UPSC Mock Test III - GS - Paper II -Results<span></span>  </a> <br /></span>    
                <span className="d-block"><a className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/mock/TVM-MOCKTEST-3-GS-RESULT.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  />ALL INDIA UPSC Mock Test 3 - GS - Paper I (Trivandrum)-Results<span></span>  </a> <br /></span>    
                <span className="d-block"><a className='text-danger ' target='_blank' href="https://www.shankariasacademy.com/pdf/UPSC-2026/mock/TVM-MOCKTEST-3-CSAT-RESULT.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  />ALL INDIA UPSC Mock Test 3 - GS - Paper II (Trivandrum)-Results<span></span>  </a> <br /></span>    
            
            </div> 

                    <div className="col-12 text-center  pb-2 pt-2">
                        <h3 className={`${styles.sectiontitle} text-center pt-3`}> All India UPSC Prelims Mock Test III 2026 - Key <br /></h3>
                        <span className="d-block"><a className='text-danger  ' target='_blank' href="https://shankariasacademy.in-maa-1.linodeobjects.com/SIA_UPSC_PRELIMS_ALL_INDIA_MOCK_2026_TEST_III_GS_1.pdf"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  /><span>SIA UPSC PRELIMS ALL INDIA MOCK 2026 TEST III GS 1</span>  </a> <br /></span> 
                        <span className="d-block"><a className='text-danger  ' target='_blank' href="https://shankariasacademy.in-maa-1.linodeobjects.com/SIA_UPSC_PRELIMS_ALL_INDIA_MOCK_2026_TEST_III_GS_2.pdf
"><Image src={arRow} width="40" height="40" alt="New_icon" className="img-fluid mx-2"  /><span>SIA UPSC PRELIMS ALL INDIA MOCK 2026 TEST III GS 2</span>  </a> <br /></span> 
                    </div> 
                </div>
            </div>
        </div>
    </div> */}
      
   {/*BranchAddress */} 

   {/* <section className="pt-md-3 pt-lg-4" style={{ background: '#E2F6FF 0% 0% no-repeat padding-box' }}>
        <div className="container"> 
      
      <div className={`${styles.head}  pt-2 pb-2`}>
        <h3>All India Mock Test - Venue</h3>
      </div>
     
        <div className="row">
          <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                     <span>CHENNAI - ANNA NAGAR</span>
                      <p >Door No 18, Old plot No 109, New plot No 259, AL Block, 4th Avenue, Shanthi Colony, Anna Nagar, Chennai-600040. <br/>76677 66266</p>
                  </div>

                  <div className={`${styles.addbox} px-4 pt-2`} >
                  <span>SHRI KRISHNASWAMY COLLEGE FOR WOMEN</span>
                      <p>48, 4th Street, AC Block, Anna Nagar, Chennai–600040</p>
                  </div>
              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox}  `}>
               <div className="row pt-3 pb-3">
                  <div className={`${styles.addbox} px-4 pt-2`} >
                  <span>CHENNAI - ADYAR </span>
                      <p >No-2/23, 3rd Cross Street, Padmanabhanagar, Adyar, Chennai-600 020. <br/>90252 78278</p>
                  </div>

              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                     <span>BENGALURU</span>
                      <p >No-34, 2nd stage, Basaveshwara HBCS layout, Chandra layout bus stand road, Bengaluru, Karnataka-560040.<br/>Landmark : Opposite to Karur Vysya Bank <br/>72593 23266</p>
                  </div>

                <div className={`${styles.addbox} px-4 pt-2`} >
                  <span>K.V.V Public School</span>
                      <p >Behind BMTC Complex, 7th Main Road,<br/>Subbanna Garden, Vijayanagar, Bengaluru .<br/>Karnataka - 560040 <br/>+91 8197292121</p>
                  </div> 
              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox}  h-90  `}>
               <div className="row pt-3 pb-3">
                  <div className={`${styles.addbox} px-4 pt-2`}>
                  <span>DELHI  </span>
                      <p >Upper Ground Floor, 25, Pusa Road,<br/>Delhi-110060. <br/>88991 80180</p>
                  </div>
                 
                 <div className={`${styles.addbox} px-4 pt-2`} >
                  <span>JVSD GIRLS SR SECONDARY SCHOOL </span>
                      <p>
Metro Station, D -2
Link Road, Ashoka Pahari,<br /> Subhash Nagar Near Jandewalan Karol Bagh,<br /> New Delhi 110005.
 </p>
                  </div>

              </div>
         </div>
     </div>

    

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox}  h-100 `}>
               <div className="row pt-3 pb-3">
                  <div className={`${styles.addbox} px-4 pt-2`} >
                  <span>THIRUVANANTHAPURAM</span>
                      <p >2nd floor, Condor Plaza, TC 2/2421, Pattom Palace P.O., Thiruvananthapuram. <br/>Kerala-695 004.<br/>79949 36555</p>
                  </div>

              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                  <div className={`${styles.addbox} px-4 pt-2`} >
                  <span>HYDERABAD</span>
                      <p >4th floor, Pasham Amrutha Ram Residency, Municipal No :1-2-234/13/46/4, Near bake zone bakery, Domalguda, Arvind nagar, Himayathnagar, Hyderabad <br/>Telangana – 500029<br/>83091 25825</p>
                  </div>

              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                     <span>Madurai</span>
                     <p>340 MIG Colony, GSP Plaza, Bata show room, 5th floor, Anna Nagar, Sathamangalam, <br/>Madurai-625020.<br/> 97896 22555</p>
                      
                  </div>

              </div>
         </div>
     </div> 


     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                     <span>Salem</span>
                     <p>No.207/5 United Arcade, Kauveri Avenue, State Bank Colony, Junction Main Road,  <br/>Salem-636 004.<br/> 89400 80039</p>
                      
                  </div>

              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                     <span>Trichy</span>
                     <p>N.R.Towers, A9 (N), Salai Road, Thillai Nagar, Trichy-620 018. <br/>Landmark: LIC -Rock Fort Branch Building<br/>97896 64555</p>
                      
                  </div>

              </div>
         </div>
     </div>

     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                     <span>Coimbatore</span>
                     <p>No.268 A, First Main Road , Anna Nagar , Peelamedu, <br/>Coimbatore-641 009.<br/>7305951898</p>
                      
                  </div>

              </div>
         </div>
     </div>

     
     <div className="col-md-6 col-lg-4 col-12 mb-3">
            <div className={`${styles.contactbox} h-100 `}>
               <div className="row pt-3 pb-3">
                    <div className= {`${styles.addbox} px-4 pt-2`}>
                     <span>MEGHALAYA </span>
                     <p>Will be update through mail</p>
                      
                  </div>

              </div>
         </div>
     </div>

    </div>
        </div>
        <br/>


   </section> */}
            
    <Footer />

    </>

    )
}

export default allIndiaPrelimsMockTestSeries;